import React from 'react';

import styles from './Tokens.module.scss'

/**
 * The goal of this component is to show a snippet of information about a token.   
 * It can optionally show/hide the info (all shown by default) and optionally include an onClick on the top portion of the information  
 *  
 * @param {object} token - the token that's data is being displayed.  This should include the "product_variants" from the product  
 * @param {bool} showName - if the name should show at the top of the token  
 * @param {bool} showPrice - if the price should be shown on the second line  
 * @param {bool} showStatus - if the status is shown (and will be shown in different colors based on the status)  
 * @param {bool} showDescription - if the description is shown at the bottom of the token details  
 * @param {func} onClick - if there's something that will happen when clicking the top details, what the function does  
 */
export const TokenInformation = ({
    token=null,
    showName=true,
    showPrice=true,
    showStatus=true,
    showDescription=true,
    onClick=null
})=>{

    if(!token) return
    let tokenVariant = token?.product_variants && token?.product_variants?.length > 0 ? token?.product_variants[0] :  null
 
    return(
        <>
            <p className={styles["token-info"]}>
                <span onClick={onClick} className="cp">
          
                    {showName &&
                        <span className={styles["token-name"]}>
                            {token.name}
                        </span>
                    }
                    {(showPrice || showStatus) &&
                        <br />
                    }
                    {showPrice && tokenVariant &&
                        <span>
                            ${tokenVariant?.price} {" "}
                        </span>
                    }
                    {(showPrice || showStatus) &&
                        <span>
                            -- 
                        </span>
                    }
                    {showStatus && tokenVariant &&
                        <span className={styles[`token-status-${tokenVariant?.product_status_id}`]}>
                            {" "}{tokenVariant?.product_status_name}
                        </span>
                    }

                </span>
                <br />
                {showDescription &&
                    <>  
                        <br />
                        {token?.description}
                    </>
                }
            </p>
        </>
    )
}